import React, { useEffect, useState, useRef } from 'react';
import { useUserStore } from 'Store/userStore';
import PortalService from 'Services/PortalService';
import AccessService from 'Services/AccessService';
import { Link } from 'react-router-dom';
import { Container, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { getQueryString, assignWindowLocation, getMediaUrl } from 'Utils/Helpers';
import CustomModal from 'Components/UI/CustomModal';
import NoDataSection from 'Components/UI/NoDataSection';
import { isDesktop } from 'react-device-detect';

const Apps = () => {
    const hasRedirected = useRef(false);
    const user = useUserStore((state) => state.user);
    const [targetApp, setTargetApp] = useState(null);
    const [accesses, setAccesses] = useState([]);
    const [closePage, setClosePage] = useState(false);

    const RedirectToAppQuery =
        getQueryString(location.search, 'redirect_to') &&
        decodeURIComponent(getQueryString(location.search, 'redirect_to'));
    const RedirectToAppId =
        getQueryString(location.search, 'appId') && decodeURIComponent(getQueryString(location.search, 'appId'));
    const autoClose =
        getQueryString(location.search, 'auto-close') &&
        decodeURIComponent(getQueryString(location.search, 'auto-close'));

    useEffect(() => {
        if (user) {
            if (RedirectToAppId && !hasRedirected.current) {
                hasRedirected.current = true;
                AccessService.getByUserIdAndAppId(RedirectToAppId)
                    .then((response) => {
                        onGoto(response.data.app, true);
                    })
                    .catch((error) => {
                        console.error('Error fetching access:', error);
                    });
            }
            PortalService.getAccesses(user.id)
                .then((result) => {
                    if (result.status === 200) {
                        const sorted = result.data.sort((a, b) => a.app.noAuth - b.app.noAuth);
                        setAccesses(sorted);
                    }
                })
                .catch((error) => {
                    console.error('Error fetching accesses:', error);
                });
        }
    }, [user]);

    const onGoto = (app, refresh = false) => {
        if (app.disabled) {
            toast.warning('Cette application est actuellement désactivée.');
            return;
        }

        PortalService.goto(app.appId)
            .then((response) => {
                if (app.appType === 1 && !isDesktop) {
                    toast.warning('Cette application est uniquement disponible sur desktop.');
                    return;
                }
                setTargetApp(app);
                let url = app.noAuth ? app.url : `${app.url}/?cliam_token=${response.data}`;
                if (app.appType === 1) url = `${app.deepLink}${response.data}`;
                const REDIRECT_TO = RedirectToAppQuery
                    ? `${url.includes('?') ? '&' : '?'}redirect_to=${encodeURIComponent(RedirectToAppQuery)}`
                    : '';
                const urlToGo = RedirectToAppQuery && RedirectToAppId === app.appId ? `${url}${REDIRECT_TO}` : url;

                assignWindowLocation(urlToGo, app.noAuth ? 'blank' : 'same');

                if (refresh && app.appType === 1 && autoClose === 'true') {
                    setClosePage(true);
                    setTimeout(() => {
                        console.log('auto closed');
                        setClosePage(true);
                        window.close();
                    }, 10000);
                }
            })
            .catch((error) => {
                console.error('Error during portal access:', error);
            });
    };

    return (
        <>
            {targetApp && <AutoClosingInfo appName={targetApp.name} time={1000 / 100} show={closePage} />}
            <Container className="guide_apps-container">
                <div className="row">
                    <h2>&nbsp;</h2>
                </div>

                <div className="row">
                    {user?.ROLE === 'SUPERADMIN' && (
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mb-2 card-same-height">
                            <Link to="/admin" className="custom-card-link">
                                <div className="card">
                                    <img src="/images/apps/cliam.jpg" className="card-img-top" alt="cliam admin" />
                                    <div className="wrapper-card-title text-center">
                                        <div className="icon-card-title">
                                            <img
                                                src="/images/super_admin.svg"
                                                alt="super admin"
                                                style={{ width: '15pt' }}
                                            />
                                        </div>
                                        <div className="text-card-title">
                                            <h5>Cliam Admin</h5>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    )}
                    {accesses.length > 0
                        ? accesses.map((access, key) => {
                              if (access.app.listed) {
                                  return (
                                      <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mb-2 card-same-height app-box-wrapper"
                                          key={key}
                                      >
                                          <Link to="#" className="custom-card-link" onClick={() => onGoto(access.app)}>
                                              <div className="card">
                                                  {!access.app.noAuth && <div className="app-card-ribbon"></div>}
                                                  <img
                                                      src={getMediaUrl(access.app.logo)}
                                                      className="card-img-top"
                                                      alt={access.app.name || 'App'}
                                                  />
                                                  <div className="wrapper-card-title text-center">
                                                      <div className="icon-card-title">
                                                          <img
                                                              src={
                                                                  access.app.appType === 1
                                                                      ? '/images/desktop.svg'
                                                                      : '/images/web.svg'
                                                              }
                                                              alt={access.app.appType === 1 ? 'desktop' : 'web'}
                                                              style={{ width: '15pt' }}
                                                          />
                                                      </div>
                                                      <div className="text-card-title">
                                                          <h5>{access.app.name}</h5>
                                                      </div>
                                                  </div>
                                              </div>
                                          </Link>
                                          <OverlayTrigger
                                              placement="top"
                                              overlay={
                                                  <Tooltip id={`tooltip-${key}`}>{access.app.description}</Tooltip>
                                              }
                                          >
                                              <Link
                                                  className="app-box-interogation"
                                                  to={`/support/${access.app.appId}`}
                                              >
                                                  ?
                                              </Link>
                                          </OverlayTrigger>
                                      </div>
                                  );
                              }
                              return null;
                          })
                        : user?.ROLE !== 'SUPERADMIN' && (
                              <NoDataSection
                                  title="Aucune application n’a été trouvée."
                                  description="Veuillez contacter S.I. en cas de problème ou si vous avez besoin d'informations."
                              />
                          )}
                </div>
            </Container>
        </>
    );
};

export default Apps;

const AutoClosingInfo = ({ time, show, appName }) => {
    const [countdown, setCountdown] = useState(time);

    useEffect(() => {
        if (show && countdown > 0) {
            const timer = setInterval(() => {
                setCountdown((prevCountdown) => prevCountdown - 1);
            }, 1000); // Decrement every second (1000 ms)
            return () => clearInterval(timer);
        }
    }, [show, countdown]);

    return (
        <CustomModal
            show={show}
            handleClose={() => {}}
            title="Cette page se fermera automatiquement"
            size="lg"
            showHeader={false}
            showFooter={false}
            backdrop="static"
            centered
        >
            <>
                <style>
                    {`
                    .creative-timer-container {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        padding: 15px;
                        position: relative;
                    }
                    
                    .timer-circle-container {
                        position: relative;
                        width: 80px;
                        height: 80px;
                        margin-bottom: 15px;
                    }
                    
                    .timer-circle-bg {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                        background: linear-gradient(135deg, #20B2AA 0%, #32CD32 100%);
                        box-shadow: 
                            0 8px 32px rgba(32, 178, 170, 0.3),
                            inset 0 2px 4px rgba(255, 255, 255, 0.2);
                        animation: timerPulse 2s ease-in-out infinite;
                    }
                    
                    .timer-inner-circle {
                        position: absolute;
                        top: 6px;
                        left: 6px;
                        width: calc(100% - 12px);
                        height: calc(100% - 12px);
                        border-radius: 50%;
                        background: white;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        box-shadow: inset 0 1px 4px rgba(0, 0, 0, 0.1);
                    }
                    
                    .timer-number {
                        font-size: 24px;
                        font-weight: bold;
                        color: #20B2AA;
                        font-family: 'Courier New', monospace;
                        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
                        animation: numberBounce 1s ease-in-out infinite;
                    }
                    
                    .timer-progress-ring {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        transform: rotate(-90deg);
                    }
                    
                    .timer-progress-circle {
                        transition: stroke-dashoffset 1s ease-out;
                        filter: drop-shadow(0 0 8px rgba(50, 205, 50, 0.6));
                    }
                    
                    .timer-text {
                        color: #6c757d;
                        font-size: 14px;
                        font-weight: 500;
                        margin-bottom: 10px;
                        text-align: center;
                    }
                    
                    .timer-status {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 6px;
                        color: #32CD32;
                        font-size: 12px;
                        font-weight: 500;
                    }
                    
                    .timer-status-dot {
                        width: 6px;
                        height: 6px;
                        border-radius: 50%;
                        background: #32CD32;
                        animation: statusDotPulse 1.5s ease-in-out infinite;
                    }
                    
                    .floating-elements {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        pointer-events: none;
                    }
                    
                    .floating-dot {
                        position: absolute;
                        width: 4px;
                        height: 4px;
                        border-radius: 50%;
                        background: rgba(32, 178, 170, 0.4);
                        animation: floatDot 3s ease-in-out infinite;
                    }
                    
                    .floating-dot:nth-child(1) {
                        top: 20%;
                        left: 20%;
                        animation-delay: 0s;
                    }
                    
                    .floating-dot:nth-child(2) {
                        top: 30%;
                        right: 25%;
                        animation-delay: 1s;
                    }
                    
                    .floating-dot:nth-child(3) {
                        bottom: 25%;
                        left: 30%;
                        animation-delay: 2s;
                    }
                    
                    @keyframes timerPulse {
                        0%, 100% { 
                            transform: scale(1);
                            box-shadow: 
                                0 8px 32px rgba(32, 178, 170, 0.3),
                                inset 0 2px 4px rgba(255, 255, 255, 0.2);
                        }
                        50% { 
                            transform: scale(1.05);
                            box-shadow: 
                                0 12px 40px rgba(32, 178, 170, 0.4),
                                inset 0 2px 4px rgba(255, 255, 255, 0.3);
                        }
                    }
                    
                    @keyframes numberBounce {
                        0%, 100% { transform: scale(1); }
                        50% { transform: scale(1.1); }
                    }
                    
                    @keyframes statusDotPulse {
                        0%, 100% { opacity: 1; transform: scale(1); }
                        50% { opacity: 0.6; transform: scale(1.2); }
                    }
                    
                    @keyframes floatDot {
                        0%, 100% { 
                            opacity: 0.3; 
                            transform: translateY(0px) scale(1); 
                        }
                        50% { 
                            opacity: 0.8; 
                            transform: translateY(-10px) scale(1.2); 
                        }
                    }
                `}
                </style>

                <div className="creative-timer-container">
                    {/* Floating background elements */}
                    <div className="floating-elements">
                        <div className="floating-dot"></div>
                        <div className="floating-dot"></div>
                        <div className="floating-dot"></div>
                    </div>

                    {/* Main timer circle */}
                    <div className="timer-circle-container">
                        <div className="timer-circle-bg"></div>

                        {/* Progress ring SVG */}
                        <svg className="timer-progress-ring" viewBox="0 0 80 80">
                            <circle
                                cx="40"
                                cy="40"
                                r="35"
                                fill="none"
                                stroke="rgba(50, 205, 50, 0.2)"
                                strokeWidth="3"
                            />
                            <circle
                                cx="40"
                                cy="40"
                                r="35"
                                fill="none"
                                stroke="#32CD32"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeDasharray={`${2 * Math.PI * 35}`}
                                strokeDashoffset={`${
                                    2 * Math.PI * 35 * (1 - (countdown > 0 ? ((10 - countdown) / 10) * 100 : 100) / 100)
                                }`}
                                className="timer-progress-circle"
                            />
                        </svg>

                        {/* Inner white circle with clock icon instead of number */}
                        <div className="timer-inner-circle">
                            <svg
                                width={20 + (10 - countdown) * (30 / 10)}
                                height={20 + (10 - countdown) * (30 / 10)}
                                viewBox="0 0 24 24"
                                fill="#1f70b8"
                            >
                                <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M16.2,16.2L11,13V7H12.5V12.2L17,14.9L16.2,16.2Z" />
                            </svg>
                        </div>
                    </div>

                    {/* Timer text */}
                    <p className="timer-text">
                        Cette fenêtre se fermera automatiquement dans <b style={{ color: '#1f70b8' }}>{countdown}</b>{' '}
                        seconde
                        {countdown !== 1 ? 's' : ''}.<br />
                        <b>{appName.toUpperCase()}</b> s’ouvrira dans quelques instants...
                    </p>

                    {/* Status indicator */}
                    <div className="timer-status">
                        <div className="timer-status-dot"></div>
                        <span>Fermeture automatique active</span>
                    </div>
                </div>
            </>
        </CustomModal>
    );
};
